import axios from 'axios';
import { BiDashboard, TopClient, DeviceUtilization, PrintingTrends, DeviceAlert, SyncLog } from '../types/bi';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const biAnalyticsService = {
  getDashboard: async (days: number = 30): Promise<BiDashboard> => {
    const response = await axios.get(`${API_URL}/bi-analytics/dashboard`, {
      params: { days },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getTopClients: async (limit: number = 10, days: number = 30): Promise<TopClient[]> => {
    const response = await axios.get(`${API_URL}/bi-analytics/top-clients`, {
      params: { limit, days },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getDeviceUtilization: async (days: number = 30): Promise<DeviceUtilization[]> => {
    const response = await axios.get(`${API_URL}/bi-analytics/device-utilization`, {
      params: { days },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getPrintingTrends: async (days: number = 30): Promise<PrintingTrends> => {
    const response = await axios.get(`${API_URL}/bi-analytics/printing-trends`, {
      params: { days },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getDeviceAlerts: async (): Promise<DeviceAlert[]> => {
    const response = await axios.get(`${API_URL}/bi-analytics/device-alerts`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getSyncHistory: async (limit: number = 10): Promise<SyncLog[]> => {
    const response = await axios.get(`${API_URL}/bi-analytics/sync-history`, {
      params: { limit },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getLastSync: async (): Promise<SyncLog> => {
    const response = await axios.get(`${API_URL}/bi-analytics/last-sync`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  getFinancialDashboard: async (months: number = 12): Promise<any> => {
    const response = await axios.get(`${API_URL}/bi-analytics/financial-dashboard`, {
      params: { months },
      headers: getAuthHeaders()
    });
    return response.data;
  }
};
